var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 -5 49 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4096 1C25.6445 1 25.8794 1.03455 26.1075 1.09674C26.871 1.30749 27.6104 1.57007 28.2668 2.05031C31.0135 4.06109 31.4004 7.89955 29.096 10.4044C29.0131 10.4942 28.9302 10.5806 28.8783 10.6359C29.6626 10.9917 30.4883 11.2543 31.1966 11.7035C33.4527 13.1304 34.5617 15.2344 34.6101 17.8982C34.6274 18.8518 34.6205 19.8053 34.6101 20.7555C34.5997 21.8299 34.0331 21.6261 32.354 21.6641C27.5274 21.7712 22.5247 21.6745 17.4942 21.6814C16.1192 21.6814 15.4074 21.823 15.4074 20.9904C15.4074 19.4944 15.2969 17.9673 15.5526 16.5059C16.0673 13.5484 17.9192 11.6758 20.8006 10.8328C20.8905 10.8052 20.9803 10.781 21.0701 10.7499C21.0943 10.743 21.1116 10.7153 21.1565 10.6773C20.4206 9.94834 19.8885 9.09842 19.6018 8.1034C18.7 4.96629 20.773 1.65644 23.993 1.09328H23.9965C24.221 1.05182 24.4456 1 24.6771 1H25.4096ZM17.0105 20.1681H32.9759C32.9759 19.2802 32.9897 18.4234 32.9725 17.57C32.9172 14.7507 30.5402 12.3184 27.714 12.2424C25.9209 12.1941 24.1209 12.1802 22.3277 12.2459C20.1615 12.3219 18.6033 13.4309 17.5875 15.3208C16.7687 16.8479 17.0658 18.5097 17.0105 20.1681ZM21.0183 6.59012C21.0148 8.79093 22.8045 10.5771 25.0053 10.5737C27.1923 10.5702 28.944 8.82548 28.9751 6.62122C29.0062 4.45496 27.2061 2.59274 25.0122 2.61001C22.7458 2.63074 21.0425 4.37895 21.0183 6.59012Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 48.519C48.6786 48.9059 48.264 48.9958 47.7665 48.9958C42.1591 48.9819 36.5552 48.9854 30.9478 48.9854C30.0253 48.9854 29.7766 48.747 29.7869 47.8245C29.8042 46.5635 29.7489 45.2886 29.8837 44.0379C30.1946 41.1323 32.3712 38.738 35.2216 38.0193C35.3252 37.9917 35.4289 37.9537 35.5843 37.9019C34.2162 36.551 33.615 34.9375 33.843 33.0615C34.0227 31.5931 34.7275 30.3804 35.8746 29.4372C38.0857 27.6268 41.3472 27.8134 43.3753 29.8415C45.317 31.7866 45.7868 35.3141 43.2267 37.9088C43.4236 37.9641 43.5964 38.0021 43.7657 38.0574C46.6195 39.004 48.3746 40.9181 48.9136 43.9031C48.9274 43.9757 48.9723 44.0413 49 44.1104C49 45.5823 49 47.0506 49 48.519ZM47.383 47.3719C47.383 46.4287 47.4452 45.5339 47.3727 44.6529C47.1205 41.5607 44.7884 39.4324 41.6789 39.4152C40.1483 39.4048 38.6178 39.4117 37.0873 39.4152C36.7763 39.4152 36.4585 39.4186 36.1544 39.4773C33.4077 39.9783 31.6215 41.9511 31.4315 44.7323C31.3728 45.6099 31.4211 46.4944 31.4211 47.3754C36.7729 47.3719 42.0624 47.3719 47.383 47.3719ZM39.409 37.7671C41.6167 37.7602 43.3995 35.9671 43.3822 33.7697C43.3684 31.6035 41.5822 29.8207 39.409 29.8C37.2531 29.7793 35.4047 31.6208 35.4047 33.7939C35.4012 35.974 37.2151 37.774 39.409 37.7671Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.447 37.8921C14.9168 38.0579 15.3971 38.1858 15.8428 38.3896C18.6067 39.6749 20.0578 41.8549 20.1995 44.8918C20.2478 45.9214 20.2133 46.9544 20.2064 47.984C20.2029 48.6888 19.9093 48.986 19.2114 48.986C13.4623 48.986 7.71325 48.9894 1.9642 48.986C1.28357 48.986 0.9899 48.6992 1.00026 48.0186C1.01754 46.647 0.95535 45.265 1.10737 43.9037C1.41486 41.1328 3.61912 38.7282 6.32781 38.0337C6.46255 37.9992 6.5973 37.9612 6.79423 37.9094C5.38461 36.5205 4.79381 34.869 5.05639 32.9584C5.24986 31.5453 5.9374 30.3706 7.04644 29.462C9.28525 27.6309 12.5053 27.7932 14.5472 29.8179C16.5061 31.763 17.0036 35.3112 14.447 37.8921ZM18.5929 47.376C18.5929 46.5675 18.6136 45.8074 18.5895 45.0439C18.4893 41.7167 16.1261 39.4192 12.8024 39.4123C11.1958 39.4088 9.58584 39.4019 7.97928 39.4226C6.68367 39.4399 5.55045 39.9202 4.56233 40.7528C2.45826 42.5286 2.47899 44.9229 2.63101 47.376C7.94128 47.376 13.2308 47.376 18.5929 47.376ZM10.5912 37.7677C12.7886 37.7712 14.6024 35.9642 14.5886 33.7876C14.5783 31.6144 12.7229 29.7695 10.5774 29.8006C8.39388 29.8317 6.62148 31.6075 6.61112 33.7772C6.60075 35.9711 8.38697 37.7643 10.5912 37.7677Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9322 12.5844C38.5798 12.187 38.255 11.8208 37.8992 11.42C38.179 11.1056 38.5176 10.729 38.8873 10.3145C39.295 10.7014 39.6716 11.0642 40.0965 11.4684C39.7061 11.845 39.3295 12.2043 38.9322 12.5844Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1651 46.1736C28.6019 46.2703 28.0975 46.3532 27.5205 46.45C27.4514 45.9214 27.3857 45.41 27.3167 44.8538C27.8314 44.7674 28.3048 44.6879 28.8334 44.6016C28.937 45.106 29.0441 45.6 29.1651 46.1736Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8277 7.45406C34.5582 7.95503 34.3164 8.40072 34.0642 8.87059C33.5943 8.64256 33.1521 8.42836 32.6753 8.19687C32.8895 7.70972 33.0899 7.24676 33.3179 6.72852C33.8154 6.97036 34.2922 7.19839 34.8277 7.45406Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.474 18.4648C44.6571 19.0211 44.8229 19.5152 44.9991 20.0541C44.4774 20.2061 43.9972 20.3478 43.4651 20.5033C43.3062 20.0334 43.1507 19.5877 42.9711 19.0556C43.4513 18.8656 43.9246 18.6791 44.474 18.4648Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94435 28.1042C5.3881 28.1698 4.88368 28.2286 4.33779 28.2942C4.29288 27.7207 4.25142 27.199 4.20996 26.6289C4.73511 26.6289 5.22917 26.6289 5.80961 26.6289C5.84761 27.0642 5.89253 27.5445 5.94435 28.1042Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9465 8.8668C15.487 9.13629 15.0724 9.37814 14.6129 9.64762C14.3261 9.20539 14.0497 8.78043 13.7388 8.29673C14.2121 8.01688 14.6751 7.74394 15.1795 7.44336C15.4352 7.92014 15.6735 8.36583 15.9465 8.8668Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02232 19.0411C6.49716 18.8407 6.02729 18.6645 5.51941 18.471C5.74053 17.9424 5.94091 17.4622 6.16203 16.9336C6.64573 17.1582 7.10178 17.3724 7.61657 17.6142C7.42309 18.0806 7.23652 18.5298 7.02232 19.0411Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3965 21.6738C45.4863 22.2404 45.5658 22.7518 45.6522 23.3149C45.0994 23.3806 44.6019 23.4393 44.0629 23.505C43.98 22.9798 43.904 22.4996 43.821 21.9779C44.3669 21.8742 44.861 21.7775 45.3965 21.6738Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.535 46.4537C21.9545 46.357 21.4363 46.2741 20.887 46.1842C20.9975 45.6418 21.0977 45.1477 21.2048 44.6191C21.7231 44.6986 22.2068 44.7746 22.7285 44.8575C22.6594 45.4 22.6006 45.9009 22.535 46.4537Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2512 8.29297C36.728 8.6281 37.146 8.92177 37.6193 9.25345C37.298 9.67495 36.994 10.0792 36.652 10.5318C36.2339 10.2416 35.8297 9.96517 35.3771 9.65422C35.6673 9.19817 35.9471 8.76284 36.2512 8.29297Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.665 16.2644C42.1315 15.9984 42.5702 15.7427 43.0608 15.4629C43.32 15.9604 43.5653 16.4372 43.8313 16.9451C43.3372 17.18 42.8777 17.3977 42.3768 17.6326C42.1384 17.1731 41.9138 16.7378 41.665 16.2644Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93744 23.4982C5.89253 24.0371 5.85452 24.507 5.81652 24.9838C5.27063 24.9838 4.76275 24.9838 4.20996 24.9838C4.25142 24.4103 4.29288 23.8782 4.33779 23.3047C4.88368 23.3703 5.38465 23.4325 5.93744 23.4982Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92896 15.4654C7.2399 14.9713 7.5163 14.5325 7.82379 14.0488C8.27984 14.3632 8.69444 14.65 9.14704 14.9609C8.8741 15.3963 8.61498 15.8109 8.32821 16.2635C7.86525 16.0009 7.42647 15.7521 6.92896 15.4654Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1761 46.5642C24.2107 45.9976 24.2383 45.507 24.2694 44.9922C24.7842 44.9922 25.2714 44.9922 25.8 44.9922C25.8 45.5208 25.8 46.0252 25.8 46.5642C25.2748 46.5642 24.7566 46.5642 24.1761 46.5642Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3877 9.24414C12.7263 9.68983 13.0373 10.0975 13.362 10.5259C12.9647 10.8542 12.5847 11.172 12.177 11.5071C11.8211 11.1167 11.4791 10.7367 11.0956 10.3152C11.524 9.95932 11.9351 9.62073 12.3877 9.24414Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91069 11.4648C10.3218 11.8553 10.6811 12.1973 11.075 12.5704C10.7364 12.9608 10.4151 13.334 10.0662 13.7348C9.65157 13.3996 9.25425 13.0852 8.81201 12.7259C9.17824 12.3044 9.53064 11.9036 9.91069 11.4648Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 13.735C40.366 13.3826 40.7529 13.0682 41.1848 12.7227C41.5165 13.1683 41.8343 13.5968 42.1798 14.0597C41.7376 14.3672 41.3196 14.6574 40.86 14.9753C40.556 14.5711 40.2589 14.1772 39.9307 13.735Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98385 20.0547C5.50555 20.1998 5.9927 20.338 6.53513 20.4866C6.41421 20.9944 6.29674 21.4781 6.17236 21.9929C5.64721 21.8858 5.16351 21.7856 4.61072 21.6716C4.7351 21.1361 4.85602 20.6213 4.98385 20.0547Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2148 26.5836C44.2148 26.0411 44.2148 25.554 44.2148 25.0254C44.7435 25.0254 45.2479 25.0254 45.7799 25.0254C45.7799 25.5402 45.7799 26.0481 45.7799 26.5836C45.2617 26.5836 44.7504 26.5836 44.2148 26.5836Z",
    fill: "#3A93A4",
    stroke: "#3A93A4",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ccabb897e8bb1b3a9b2dc9ade8452cb2.svg";
export { ForwardRef as ReactComponent };